import { constants } from '../config';

const initialState = {
  done: false,
  loading: false,
  errorRequest: false,
  error: null,
  info: {},
};

export default function getLiveChatParamsReducer(state = initialState, action) {
  switch (action.type) {
    case constants.GET_LIVE_CHAT_PARAMS:
      return { ...state, loading: true, errorRequest: false, error: null, done: false };
    case constants.GET_LIVE_CHAT_PARAMS_SUCCESS: {
      return {
        ...state,
        loading: false,
        done: true,
        info: {
          ...action.payload,
        },
      };
    }
    case constants.GET_LIVE_CHAT_PARAMS_FAIL:
      return { ...state, loading: false, errorRequest: true, error: { ...action.error } };

    case constants.RESET_LIVE_CHAT_PARAMS:
      return initialState;
    default:
      return state;
  }
}
